import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Admin from "@/pages/Admin";
import Intake from "@/pages/Intake";
import IntakeThanks from "@/pages/IntakeThanks";
import Card from "@/pages/Card";
import Testimonial from "@/pages/Testimonial";
import Book from "@/pages/Book";
import Promo from "@/pages/Promo";
import Promo2 from "@/pages/Promo2";
import Promo3 from "@/pages/Promo3";
import Promo4 from "@/pages/Promo4";
import Promo5 from "@/pages/Promo5";
import Promo6 from "@/pages/Promo6";
import Promo7 from "@/pages/Promo7";
import Promo8 from "@/pages/Promo8";
import PromoN from "@/pages/PromoN";
import Resume from "@/pages/Resume";
import CarouselSlide from "@/pages/CarouselSlide";
import LegacyChallenge from "@/pages/LegacyChallenge";
import LegacyWallAdmin from "@/pages/LegacyWallAdmin";
import Shop from "@/pages/Shop";
import KmsLanding from "@/pages/KmsLanding";
import KmsShop from "@/pages/KmsShop";
import MerchCheckout from "@/pages/MerchCheckout";
import MerchSuccess from "@/pages/MerchSuccess";
import OrderTracking from "@/pages/OrderTracking";
import Cart from "@/pages/Cart";
import Press from "@/pages/Press";
import Share from "@/pages/Share";
import Events from "@/pages/Events";
import { Toaster } from "sonner";
import { initPosthog } from "@/lib/posthogClient";
import AnalyticsListener from "@/components/AnalyticsListener";
import GA4Listener from "@/components/GA4Listener";

function App() {
  useEffect(() => { initPosthog(); }, []);
  return (
    <div className="App grain">
      <Toaster theme="dark" position="bottom-center" richColors />
      <BrowserRouter>
        <AnalyticsListener />
        <GA4Listener />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/intake" element={<Intake />} />
          <Route path="/intake-thanks" element={<IntakeThanks />} />
          <Route path="/card" element={<Card />} />
          <Route path="/testimonial" element={<Testimonial />} />
          <Route path="/book" element={<Book />} />
          <Route path="/promo" element={<Promo />} />
          <Route path="/promo2" element={<Promo2 />} />
          <Route path="/promo3" element={<Promo3 />} />
          <Route path="/promo4" element={<Promo4 />} />
          <Route path="/promo5" element={<Promo5 />} />
          <Route path="/promo6" element={<Promo6 />} />
          <Route path="/promo7" element={<Promo7 />} />
          <Route path="/promo8" element={<Promo8 />} />
          <Route path="/promo/:n" element={<PromoN />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/carousel/:set/:n" element={<CarouselSlide />} />
          <Route path="/sweat-for-sacrifice" element={<LegacyChallenge />} />
          <Route path="/legacy" element={<LegacyChallenge />} />
          <Route path="/sacrifice" element={<Navigate to="/legacy" replace />} />
          {/* KMS Technology — hidden partner experience. Same challenge,
              same signup/leaderboard/wall/tracker; only Shop diverges to
              /kms/shop where two exclusive team pieces are surfaced. NOT
              linked from the public nav or sitemap. */}
          <Route path="/kms" element={<KmsLanding />} />
          {/* React Router v6 is case-insensitive by default, so /KMS and
              /KMS/shop already resolve to /kms and /kms/shop. No aliases
              needed — an earlier <Navigate> route caused an infinite
              redirect loop and rendered a blank page. */}
          <Route path="/kms/shop" element={<KmsShop />} />
          {/* Year 1 is COMPLETE — the live challenge surfaces (log minutes,
              public leaderboard, legacy wall, news) are consolidated into the
              single /legacy archive page. These routes redirect there so old
              shared links keep working. Flip CHALLENGE_CLOSED on the backend
              to revive the live challenge, then restore these routes. */}
          <Route path="/kmsleaderboard" element={<Navigate to="/legacy" replace />} />
          <Route path="/kms-leaderboard" element={<Navigate to="/legacy" replace />} />
          <Route path="/kms/leaderboard" element={<Navigate to="/legacy" replace />} />
          <Route path="/sweat-for-sacrifice/log" element={<Navigate to="/legacy" replace />} />
          <Route path="/log" element={<Navigate to="/legacy" replace />} />
          <Route path="/minutes" element={<Navigate to="/legacy" replace />} />
          <Route path="/sweat-for-sacrifice/leaderboard" element={<Navigate to="/legacy" replace />} />
          <Route path="/sweat-for-sacrifice/admin" element={<LegacyWallAdmin />} />
          <Route path="/legacy-wall" element={<Navigate to="/legacy" replace />} />
          <Route path="/who-we-honor" element={<Navigate to="/legacy" replace />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/merch/checkout" element={<MerchCheckout />} />
          <Route path="/merch/success" element={<MerchSuccess />} />
          <Route path="/track" element={<OrderTracking />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/press" element={<Press />} />
          <Route path="/share" element={<Share />} />
          <Route path="/events" element={<Events />} />
          {/* Media coverage of Sweat for Sacrifice. Linked from the /legacy
              "Featured in" block + the footer. Not in the main nav yet. */}
          <Route path="/news" element={<Navigate to="/legacy" replace />} />
          <Route path="/in-the-news" element={<Navigate to="/legacy" replace />} />
          <Route path="/kit" element={<Navigate to="/press" replace />} />
          <Route path="/media" element={<Navigate to="/press" replace />} />
          <Route path="/order/track" element={<Navigate to="/track" replace />} />
          <Route path="/merch" element={<Navigate to="/shop" replace />} />
          {/* Common URL variants that people type — always land on the intended page */}
          <Route path="/testimonials" element={<Navigate to="/testimonial" replace />} />
          <Route path="/reviews" element={<Navigate to="/testimonial" replace />} />
          <Route path="/wins" element={<Navigate to="/testimonial" replace />} />
          <Route path="/wall" element={<Navigate to="/legacy" replace />} />
          <Route path="/challenge" element={<Navigate to="/legacy" replace />} />
          <Route path="/sweat-for-sacrifice/" element={<Navigate to="/legacy" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
